import React from "react";
import { Col } from "../bootstrap/index.jsx";
import Select from "../common/Select.jsx";

// SQL Parts as described in DatagridSelectBuilderService
const INITIAL_STATE = [
  {"type": "Variable", "accessor": ""},
  {"type": "Math", "value": "/"},
  {"type": "Nullif"},
  {"type": "LeftParenthesis"},
  {"type": "AggregateFunc", "func": "sum", "accessor": ""},
  {"type": "Over", "func": "PARTITION BY", "accessors": []},
  {"type": "Comma"},
  {"type": "Digit", "value": 0},
  {"type": "RightParenthesis"}
]

const AGGREGATE_OPTIONS = ['sum', 'avg'].map(a => ({value: a, label: a}));

const PercentageOverInput = ({defaultValue, onChange, columns}) => {
  const selectParts = defaultValue || INITIAL_STATE;

  const updateSqlPartField = (index, field, newValue) => {
    let newSelectParts = JSON.parse(JSON.stringify(selectParts));
    newSelectParts[index][field] = newValue;
    onChange(newSelectParts);
  }

  const numberColumns = columns
    .filter(c => c.filter == "agNumberColumnFilter") // Somewhat stupid to check based on this
    .map(v =>({value: v.field, label: v.headerName}))

  // TODO: All for now, should limit to reasonable
  const overColumns = columns
    .map(v =>({value: v.field, label: v.headerName}))


  return <>
    <Col>
      <label className="mt-1">{I18n.t('numerator')}</label>
      <Select 
      options={numberColumns} 
        onChange={(newVal) => updateSqlPartField(0, 'accessor', newVal)} 
        value={selectParts[0].accessor} 
      />
    </Col>
    <Col>
      <label className="mt-1">{I18n.t('denominator')}</label>  
    </Col>
    <Col size='xs-4'>
      <label>{I18n.t('aggregation_function')}</label>  
      <Select 
        options={AGGREGATE_OPTIONS} 
        onChange={(newVal) => updateSqlPartField(4, 'func', newVal)} 
        value={selectParts[4].func} 
      />
    </Col>
    <Col size='xs-4'>
      <label>{I18n.t('aggregation_column')}</label>  
      <Select 
        options={numberColumns} 
        onChange={(newVal) => updateSqlPartField(4, 'accessor', newVal)} 
        value={selectParts[4].accessor} 
      />
    </Col>
    <Col size='xs-4'>
      <label>{I18n.t('aggregate_over')}</label>  
      <Select 
        options={overColumns} 
        onChange={(newVal) => updateSqlPartField(5, 'accessors', newVal)} 
        value={selectParts[5].accessors}
        isMulti={true}
      />
    </Col>
    <Col>
      <span className="description">
        {I18n.t('percentage_over_description')}  
      </span> 
    </Col>
  </>
}

export default PercentageOverInput;